import { EventEmitter, Output, Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[EIN]',
  host: {
    '(ngModelChange)': 'onInputChange($event)',
    '(keydown.backspace)':'onInputChange($event.target.value, true)'
  }
})
export class EINMask {

  constructor(public model: NgControl) { }

  @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();

  onInputChange(value) {
    // var x = value.replace(/\D/g, '').match(/(\d{0,9})/);
    // var y = !x[2] ? x[1] : x[1] + x[2];

    var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,7})/);
    var y = !x[2] ? x[1] : x[1] + '-' + x[2];

    // this.model.valueAccessor.writeValue(y);
    this.model.control.setValue(y, {emitViewToModelChange: false})
    this.rawChange.emit(value);
  }
}
